/* eslint-disable prettier/prettier */
import React, { InputHTMLAttributes, useState } from 'react';
import styles from '../../styles/components/controlVariations/InputField.module.css';
import ViewIcon from '../../assets/images/icon/View.svg';
import HideIcon from '../../assets/images/icon/Hide.svg';

interface InputFieldProps extends InputHTMLAttributes<HTMLInputElement> {
	leftIcon?: React.ReactNode;
	rightIcon?: React.ReactNode;
	error?: boolean;
	helperText?: string;
	label?: string;
	required?: boolean;
}

const InputField: React.FC<InputFieldProps> = ({
	leftIcon,
	error,
	label,
	helperText,
	required = false,
	className,
	type,
	...props
}) => {
	const isPassword = type === 'password';
	const [showPassword, setShowPassword] = useState(false);

	return (
		<div className={`${styles.wrapper} ${className || ''}`}>
			{label && (
				<label className={styles.label}>
					{label}
					{required && <span className={styles.asterisk}>*</span>}
				</label>
			)}

			<div className={`${styles.container} ${error ? styles.error : ''}`}>
				{leftIcon && <span className={styles.icon}>{leftIcon}</span>}

				<input
					className={styles.input}
					type={isPassword && showPassword ? 'text' : type}
					{...props}
				/>

				{isPassword && (
					<button
						type="button"
						className={styles.eyeButton}
						onClick={() => setShowPassword(prev => !prev)}
						aria-label={
							showPassword ? 'Hide password' : 'Show password'
						}
					>
						<img
							src={showPassword ? HideIcon : ViewIcon}
							alt={
								showPassword ? 'Hide password' : 'Show password'
							}
							className={styles.eyeIcon}
						/>
					</button>
				)}
			</div>

			{helperText && (
				<p
					className={`${styles.helperText} ${error ? styles.helperError : ''}`}
				>
					{helperText}
				</p>
			)}
		</div>
	);
};

export default InputField;
